import {createSlice} from '@reduxjs/toolkit';

const scheduleModalSlice = createSlice({
  name: 'scheduleModal',
  initialState: {
    vehicle: '',
    vehicleSN: '',
    implementSN: '',
    task: '',
    recurring: true,
    timeInterval: '',
    timeIntervalUnits: '',
    engineHoursInterval: '',
    odometerInterval: '',
    implementHoursInterval: '',
    intervalString: '',
    notes: '',
    averageLaborHours: '',
    averageLaborCost: '',
    averagePartsCost: '',
    serviceTask: {},
    serviceChecklistItems: [],
    vehicleLabels: [],
    labelEdit: false,
    defaultPriority: 'medium',
  },
  reducers: {
    setInitialValues(state, action) {
      const taskData = action.payload;
      const isImplementService = taskData.serviceTask?.is_implement_service ?? false;
      state.vehicle = taskData.vehicle ?? taskData.implement ?? '';
      state.vehicleSN = isImplementService ? '' : taskData.vehicleSN ?? '';
      state.implementSN = isImplementService ? taskData.implementSN ?? '' : '';
      state.task = taskData.task;
      state.recurring = taskData.serviceTask.recurring;
      state.timeInterval = Number(taskData.serviceTask.time_interval) ? taskData.serviceTask.time_interval : '';
      state.timeIntervalUnits = taskData.serviceTask.time_units;
      state.engineHoursInterval = Number(taskData.serviceTask.engine_hours_interval)
        ? taskData.serviceTask.engine_hours_interval
        : '';
      state.odometerInterval = Number(taskData.serviceTask.odometer_interval)
        ? taskData.serviceTask.odometer_interval
        : '';
      state.implementHoursInterval = Number(taskData.serviceTask.implement_hours_interval)
        ? taskData.serviceTask.implement_hours_interval
        : '';
      state.intervalString = taskData.intervalString;
      state.notes = taskData.notes;
      state.serviceTask = taskData.serviceTask;
      state.currOdometer = taskData.currOdometer;
      state.currEngineHours = taskData.currEngineHours;
      state.averageLaborHours = taskData.averageLaborHours || '';
      state.averageLaborCost = taskData.averageLaborCost || '';
      state.averagePartsCost = taskData.averagePartsCost || '';
      state.machineType = taskData.machineType;
      state.serviceChecklistItems = taskData.serviceTask.service_checklist_items ?? [];
      state.vehicleLabels = taskData?.labelEdit ? taskData.serviceTask.vehicle_labels ?? [] : [];
      state.labelEdit = taskData?.labelEdit == true;
      state.defaultPriority = taskData.serviceTask?.default_priority || 'medium';
    },
  },
});

export const {setInitialValues} = scheduleModalSlice.actions;
export default scheduleModalSlice.reducer;
